import apiClient from '../client';
import type { Attachment, AttachmentEntityType, CreateAttachmentRequest } from '../../types';

const attachmentService = {
  getForEntity: async (entityType: AttachmentEntityType, entityId: string) => {
    const response = await apiClient.get<Attachment[]>('/attachments', { params: { entityType, entityId } });
    return response.data;
  },

  create: async (data: CreateAttachmentRequest) => {
    const response = await apiClient.post<Attachment>('/attachments', data);
    return response.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/attachments/${id}`);
  },
};

export default attachmentService;
